export default __webpack_public_path__ + "static/media/pdf_file_white.3d4b2638.svg";